// components/PlaylistLibrary/index.js

import PlaylistLibrary from './PlaylistLibrary';

export default PlaylistLibrary;
